import {
  Box,
  ControlPrefix,
  FormControlSizes,
  IconName,
  MultiSelectCheckboxDropdown,
  type FilterableSelectProperty,
} from '@talos/kyoko';
import { useMemo } from 'react';
import { resolveExchangeDisplayName } from '../core';
import { FUNDING_RATE_MAX_EXCHANGES } from './tokens';

interface ExchangeSelectProps {
  availableExchanges: string[];
  selectedExchanges: string[];
  onSelectedExchangesChange: (exchanges: string[]) => void;
  exchangeNameByExchangeId: ReadonlyMap<string, string>;
  width?: string;
}

export function ExchangeSelect({
  availableExchanges,
  selectedExchanges,
  onSelectedExchangesChange,
  exchangeNameByExchangeId,
  width,
}: ExchangeSelectProps) {
  const exchangeProperty = useMemo<FilterableSelectProperty<string, string>>(
    () => ({
      key: 'exchange',
      label: 'Exchanges',
      icon: IconName.QuestionMarkCircle,
      options: availableExchanges,
      getOptionLabel: id => resolveExchangeDisplayName(id, exchangeNameByExchangeId),
      allowSelectAll: false,
    }),
    [availableExchanges, exchangeNameByExchangeId]
  );

  const isItemDisabled = useMemo(
    () =>
      selectedExchanges.length >= FUNDING_RATE_MAX_EXCHANGES
        ? (exchange: string) => !selectedExchanges.includes(exchange)
        : undefined,
    [selectedExchanges]
  );

  const dropdown = (
    <MultiSelectCheckboxDropdown
      prefix={<ControlPrefix>Exchanges</ControlPrefix>}
      property={exchangeProperty}
      selections={selectedExchanges}
      onSelectionsChange={onSelectedExchangesChange}
      size={FormControlSizes.Small}
      buttonTestID="funding-rate-exchange-select"
      dropdownTestID="funding-rate-exchange-dropdown"
      isItemDisabled={isItemDisabled}
    />
  );

  return width != null ? (
    <Box w={width} flexShrink={0}>
      {dropdown}
    </Box>
  ) : (
    dropdown
  );
}
